import ControlArea from "components/Layout/ControlArea";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import blogIcon from "assets/svgs/blog.svg";
import Table from "./Table";
import BootyPagination from "components/shared/Pagination";
import BlogsTitles from "./titles";
const Blogs = () => {
  const { blogs, metadata } = useSelector((state) => state.blogs);
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <>
      <div className="stores-wrap">
        <ControlArea
          btnTxt="addBlog"
          cardTxt="blogs"
          icon={blogIcon}
          url="/blogs/addblog"
        />
        <BlogsTitles />
        <Table data={blogs} currentPage={currentPage} />
        {metadata?.totalResults > 8 && (
          <BootyPagination
            metaData={metadata}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            limit={10}
          />
        )}
      </div>
    </>
  );
};

export default Blogs;
